// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__-iT49","legacyBtn":"MutateMid_legacyBtn__10mqQ"};